// extracted by mini-css-extract-plugin
export var column = "form-module--column--sOwDQ";
export var form = "form-module--form--zb8AM";
export var halfWidth = "form-module--halfWidth--435W0";
export var row = "form-module--row--Dopit";
export var verticalcenter = "form-module--verticalcenter--RsKb8";